module.exports = __webpack_public_path__ + "img/icons-16-line-delete.55d4ad02.svg";